<template>
  <div>
    <v-card class='py-3 px-5'>
      <div
        v-if='!loading'
        class='d-flex justify-space-between align-center'
      >
        <h3>
          {{ title }}
          <span class='ml-2 primary--text font-weight-bold text-capitalize'>
            {{ selectedMember.name }}
          </span>
        </h3>
        <v-btn
          :color='btnColor'
          class='text-capitalize font-weight-bold'
          outlined
          @click='isDialogOpen = true'
        >
          Change Company
        </v-btn>
      </div>
      <div
        v-else
        class='d-flex justify-space-between align-center'
      >
        <v-skeleton-loader type='text'></v-skeleton-loader>
        <v-skeleton-loader type='button'></v-skeleton-loader>
      </div>
    </v-card>
    <change-company-dialog
      v-if='!loading'
      :is-open='isDialogOpen'
      :members='members'
      :selected-member-id='selectedMember.id'
      @close-dialog='isDialogOpen = false'
    />
  </div>
</template>

<script>
import ChangeCompanyDialog from '@/components/change-company/change-company-dialog'

export default {
  name: 'change-company',
  components: { ChangeCompanyDialog },
  props: {
    members: {
      type: Array,
      required: true,
      default: () => []
    },
    selectedMember: {
      type: Object,
      required: true,
      default: () => ({})
    },
    btnColor: {
      type: String,
      default: 'primary'
    },
    title: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isDialogOpen: false
    }
  }
}
</script>

<style scoped>
::v-deep .v-skeleton-loader__text {
  height: 28px !important;
  width: 800px !important;
  margin-bottom: 0;
  background: rgba(91, 141, 215, .7) !important;
}
::v-deep .v-skeleton-loader__button {
  height: 36px !important;
  width: 160px !important;
  background: rgba(91, 141, 215, .7) !important;
}
@media (max-width: 1450px) {
  ::v-deep .v-skeleton-loader__text {
    width: 400px !important;
  }
}
@media (max-width: 1000px) {
  ::v-deep .v-skeleton-loader__text {
    width: 250px !important;
  }
}
@media (max-width: 800px) {
  ::v-deep .v-skeleton-loader__text {
    width: 450px !important;
  }
}
@media (max-width: 800px) {
  ::v-deep .v-skeleton-loader__button {
    display: none;
  }
}
</style>
